/**
 * Asks the browser to keep this site's storage when space runs short (StorageManager.persist):
 * the device's player key lives there, and with a new key the statistics start a second card
 * and the kid's calibration stops applying (apps/server/README.md, «Кто есть кто»). Chrome
 * grants it silently to an installed or often used app, Safari to a home-screen app; a browser
 * may also ask the player or say no. Best effort: asked once, failures ignored.
 */

/** The part of navigator.storage this needs (undefined: no Storage API, e.g. an old browser). */
export type PersistableStorage = Pick<StorageManager, 'persist' | 'persisted'>;

export async function keepStorage(storage: PersistableStorage | undefined): Promise<boolean> {
  if (!storage || typeof storage.persist !== 'function') return false;
  try {
    if (await storage.persisted()) return true;
    return await storage.persist();
  } catch {
    return false;
  }
}

/** navigator.storage where there is one. */
export function browserStorageManager(): PersistableStorage | undefined {
  return typeof navigator !== 'undefined' && 'storage' in navigator ? navigator.storage : undefined;
}
